<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 font-45 colorPrincipal">
            ÁLBUM REPÚBLICA PERUANA 1900
            <br>
            <span class="fontMS300">
                ALBORES Y ANHELOS<br>
                DE MODERNIZACIÓN<br>
            </span>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp; &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio5/album-republica-peruana">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio5/album-republica-peruana">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio5/album-republica-peruana">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img001.jpg">
</section>

<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-center font-24">
                    EL <span class="fontMS500Italic">ÁLBUM REPÚBLICA PERUANA 1900</span> ES UN SIGNIFICATIVO DOCUMENTO
                    FOTOGRÁFICO QUE FUE PLANIFICADO Y
                    COMISIONADO POR EL ESTADO PERUANO PARA SER EXHIBIDO EN LA EXPOSICIÓN UNIVERSAL DE PARÍS DEL AÑO
                    1900.
                    <br>
                </p>
                <p class="fontMS100 text-justify font-24">
                    <br>
                    Este demandó una inédita cobertura del territorio nacional y es un elocuente testimonio de la visión
                    que la clase dirigente tenía sobre la representación del progreso material, la modernidad y de la
                    integración territorial a través de su potencial económico. Más de quinientas fotografías registran
                    la dimensión urbana y rural nacional, su capacidad industrial, minera y ferroviaria, así como
                    evidencian los proyectos extractivistas y “civilizadores” sobre la región amazónica y sus
                    comunidades.
                    <br><br>
                    Desde su implementación en Europa (1851) y Estados Unidos (1876), las exposiciones universales
                    constituían una oportunidad para la promoción entre naciones. La exhibición de sus recursos
                    naturales, productos comerciales y su estado tecnológico y científico buscaba atraer capitales
                    financieros e industriales. La participación en la Feria Internacional de París de 1900 fue abordada
                    como una política de Estado. Desde el recién fundado Ministerio de Fomento y Obras Públicas (1896),
                    cuyos funcionarios debían promover el desarrollo económico y material del país, se estableció una
                    comisión que tuvo a su cargo la construcción del pabellón oficial y el envío de una selección de
                    muestras minerales, forestales y agrícolas, además de la implementación de una extensa biblioteca
                    con libros, revistas y publicaciones sobre derecho, historia, literatura, medicina, milicia,
                    botánica o mineralogía.
                    <br><br>
                    Se conservan dos ejemplares del <span class="fontMS100Italic">Álbum República Peruana 1900</span>,
                    uno en el Instituto Raúl Porras
                    Barrenechea de la Universidad Nacional Mayor de San Marcos y otro en la Biblioteca Nacional del
                    Perú. Este último presenta cuatro recorridos:
                    <br><br>
                    <span>
                        <ul>
                            <li> Lima - Callao - La Legua - La Punta - Chorrillos </li>
                            <li> Lima - Junín y Pasco - San Martín - Amazonas - Cajamarca - San Martín - Loreto </li>
                            <li> Arequipa - Puno - Cusco - Moquegua - Tacna - Arica </li>
                            <li> Piura - Lambayeque - Cajamarca - La Libertad - Áncash</li>
                        </ul>
                    </span>
                    <br>
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco_L">
    <div class="container">
        <div class="col-sm-12">
            <p>
                <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_LINEA2.jpg">
            </p>
        </div>
    </div>
</div>
<div class="fondoBlanco_FG">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row pb-2">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio5\ET02_MS06_ALBUM_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;margin-top: 1%;"
                            class="fontMS700 text-center colorPrincipal font-40 titleSubsec">
                            FERNANDO GARREAUD, EDITOR
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio5\ET02_MS06_ALBUM_LINEA1-recortada2.png">
                    </div>
                </div>

                <p style="line-height: 130%;margin-top: -0.5%;" class="text-center fontMS300 colorPrincipal font-40">
                    CHARLES KROEHLE Y GEORG HÜEBNER,<br> FOTÓGRAFOS EXPLORADORES
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio5\ET02_MS06_ALBUM_LINEA1-recortada2.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br><br>
                    EN 1899, PARA LA EDICIÓN Y ENCUADERNACIÓN DEL <span class="fontMS500Italic">ÁLBUM REPÚBLICA PERUANA
                        1900</span>, LA DIRECCIÓN DE FOMENTO DEL MINISTERIO DE FOMENTO Y OBRAS PÚBLICAS, CONTRATÓ AL
                    FOTÓGRAFO FERNANDO GARREAUD.
                </p>
                <br><br>
                <p class="fontMS100 text-justify font-24">
                    En la obra se debía destacar el registro de la
                    <span class="fontMS100Italic">
                        Vía Pichis,
                    </span>
                    ambiciosa ruta que unía el Callao con la ciudad amazónica de Iquitos a través de un accidentado
                    camino terrestre y complicada navegación fluvial. Por este motivo, Garreaud utilizó el material
                    documental realizado por los fotógrafos Charles Kroehle y Georg Hüebner entre 1888 y 1891. En una
                    aventura pionera como registro visual y sostenida por tres años, ambos documentaron el paisaje
                    exuberante de la Amazonía, sus colonizadores y sobre todo a la población indígena.
                </p>
                <br>
            </div>
            <div class="row">
                <div class="col-sm-3 libro">
                    <a href="https://hdl.handle.net/20.500.14428/59629" target="_blank" style="color: black;">
                        <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img002.jpg">
                        <div class="overlay">
                            <p class="fontMS500 text-center">
                                Adolph Dubreuil. <br>
                                <span class="fontMS100">
                                    Retrato de Fernando Garreaud (sentado), su madre María Cristina Leblanc Tessier y
                                    hermano (1896).
                                </span>
                            </p>
                        </div>
                    </a>
                    <br><br>
                </div>
                <div class="col-sm-3 libro">
                    <a href="https://hdl.handle.net/20.500.14428/55842" target="_blank" style="color: black;">
                        <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img003.jpg">
                        <div class="overlay">
                            <p class="fontMS500 text-center">
                                Adolph Dubreuil<br>
                                <span class="fontMS100">
                                    Retrato de Fernando Garreaud (1897)
                                    <br>
                                    Placa de vidrio.
                                </span>
                            </p>
                        </div>
                    </a>
                    <br><br>
                </div>
                <div class="col-sm-3 libro">
                    <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img004.jpg">
                    <div class="overlay">
                        <p class="fontMS500 text-center">
                            Retrato de Charles Kroehle con herida de flecha. Ca. 1891<br>
                            <span class="fontMS100">
                                Del Album I Spanish-America, Alfred Haag, 1891-1895 <br>
                            </span>
                        </p>
                    </div>
                    <br><br>
                </div>
                <div class="col-sm-3 libro">
                    <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img004a.jpg">
                    <div class="overlay">
                        <p class="fontMS500 text-center">
                            Retrato de Georg Huëbner, Ca. 1910<br>
                            <span class="fontMS100">
                                George Huebner: fotógrafo alemão-caboclo.<br>
                                Manaos, Gobierno del Estado de Amazonas, Brasil (2013) <br>
                            </span>
                        </p>
                    </div>
                    <br><br>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container_AzulImg1">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LAS CIUDADES DEL PERÚ
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada2.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-bottom: 2%;" class="text-center fontMS300 colorPrincipal font-40">
                    HACIA EL FIN DEL SIGLO
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio5\ET02_MS06_ALBUM_LINEA1-recortada2.png">
                </div>
                <p class="fontMS500 text-center font-24 text-white">
                    <br>
                    EN LOS AÑOS SIGUIENTES AL DESASTRE QUE SIGNIFICÓ LA GUERRA CON CHILE (1879-1884), LA ECONOMÍA
                    MOSTRABA SEÑALES DE RECUPERACIÓN PRODUCTO DE LA ACERTADA COMBINACIÓN DE POLÍTICAS FISCALES Y EL
                    DESARROLLO DE LA ECONOMÍA DE EXPORTACIÓN.
                    <br>
                </p>
                <p class="fontMS100 text-justify font-24 text-white">
                    <br>
                    Si bien la integración de Lima con el resto del país había sido fragmentada y discontinua, la
                    ideología científico positivista de fines de siglo XIX impulsó desde el Estado la mejora de las
                    condiciones sanitarias de la población con el desarrollo de varias campañas que tuvieron como
                    objetivo la disminución de la mortalidad. Como resultado, el Perú inició la primera fase de su
                    crecimiento demográfico, sobre todo en ciudades como Lima, Arequipa, Cusco y Trujillo. Aunque el
                    país era mayoritariamente rural y andino, el aumento urbano y costeño no se detendría. Apenas
                    iniciado el siglo XX, el censo de 1908 indicaba que el 58.5% de la población de Lima no había nacido
                    en ella, muestra de que las oportunidades de trabajo y la centralización administrativa de la
                    capital alentaron la migración.
                    <br><br>
                </p>

                <!--CEL-->
                <div class="row menuWebPhone">
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/8/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img005.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    Nº 6 Lima. <br>
                                    Palacio de gobierno y Plaza principal
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/10/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img006.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 11 Lima. <br>
                                    Vista exterior de la Municipalidad <br>
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/110/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img007.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 228. Cerro de Pasco. <br>
                                    Calle de Grau <br>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/118/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img008.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 252 Tarapoto.<br>
                                    Calle del Billar <br>
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/118/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img009.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 253 Chachapoyas.<br>
                                    Plaza e iglesia <br>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/126/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img010.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 269. Iquitos.<br>
                                    Prefectura y cuartel <br>
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/126/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img011.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 271. Iquitos.<br>
                                    El puerto de Iquitos cobro dinamismo porque permitía una salida hasta el
                                    Atlántico
                                    <br>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/130/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img012.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 279. Arequipa. <br>
                                    Plaza principal <br>
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/160/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img013.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 364. Cuzco.<br>
                                    Plaza principal <br>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/164/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img014.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 378. Tacna.<br>
                                    Plaza de Colón <br>
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/166/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img015.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 381. Piura.<br>
                                    Plaza principal <br>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/170/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img016.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 392 Chiclayo.<br>
                                    Plaza y calle principal <br>
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
                <br>

                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/8/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img005.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        Nº 6 Lima. <br>
                                        Palacio de gobierno y Plaza principal
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/10/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img006.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 11 Lima. <br>
                                        Vista exterior de la Municipalidad <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/110/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img007.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 228. Cerro de Pasco. <br>
                                        Calle de Grau <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/118/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img008.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 252 Tarapoto.<br>
                                        Calle del Billar <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/118/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img009.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 253 Chachapoyas.<br>
                                        Plaza e iglesia <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/126/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img010.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 269. Iquitos.<br>
                                        Prefectura y cuartel <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/126/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img011.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 271. Iquitos.<br>
                                        El puerto de Iquitos cobro dinamismo porque permitía una salida hasta el
                                        Atlántico
                                        <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/130/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img012.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 279. Arequipa. <br>
                                        Plaza principal <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/160/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img013.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 364. Cuzco.<br>
                                        Plaza principal <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/164/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img014.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 378. Tacna.<br>
                                        Plaza de Colón <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/166/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img015.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 381. Piura.<br>
                                        Plaza principal <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/170/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img016.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 392 Chiclayo.<br>
                                        Plaza y calle principal <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                </div>

                <div class="row p4">
                    <div class="col-sm-12">
                        <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA2.jpg">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2" width="100%"
                            src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;margin-top: 4%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            ATRAVESANDO LA NACIÓN
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada2.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-bottom: 2%;" class="text-center fontMS300 colorPrincipal font-40">
                    EL PROYECTO FERROVIARIO
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada2.png">
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <br><br>
                        <p class="fontMS500 text-center font-24 text-white">
                            DESDE LA SEGUNDA MITAD DEL SIGLO XIX LOS PROYECTOS DE IMPLEMENTACIÓN DE VÍAS PARA ARTICULAR
                            EL TERRITORIO Y PERMITIR EL COMERCIO FUERON APOYADOS POR EL ESTADO POR RAZONES POLÍTICAS Y
                            ECONÓMICAS. COMO RESULTADO SE DISEÑARON PROYECTOS A LO LARGO DEL PAÍS PARA ESTABLECER LA RED
                            QUE VINCULARÍA AL PERÚ CON LA ECONOMÍA MUNDIAL.<br>
                        </p>

                        <p class="fontMS100 text-justify font-24 text-white">
                            <br>
                            Con el financiamiento estatal proveniente parte de la comercialización del guano y parte de
                            los préstamos con la banca inglesa, en 1870 comenzó la construcción en simultáneo de vías
                            férreas hacia la costa para favorecer la exportación de productos de minas y haciendas.
                            Infructuosamente se planificó que desde los puertos de Paita, Pacasmayo, Salaverry,
                            Chimbote, Callao o Ilo los trenes cruzarían la cordillera hasta los yacimientos minerales e
                            incluso continuarían su camino hasta los ríos navegables de la Amazonía. Cuando la crisis
                            económica paralizó las obras en 1876, solo la línea Mollendo-Arequipa-Puno había sido
                            concluida.
                            <br>
                        </p>
                        <p class="fontMS100 text-justify font-24 text-white">
                            Si la guerra con Chile (1879-1884) pareció sepultar durmientes y rieles, la firma del
                            contrato Grace (1889) para el pago de la deuda externa entre el Estado peruano y sus
                            acreedores, significó la entrega de las principales líneas ferroviarias del país a la
                            <span class="fontMS100Italic">Peruvian Corporation,</span> de capitales ingleses. Sin
                            embargo, esto significó que se concluyeran los tramos abandonados y que la emblemática línea
                            del Ferrocarril Central, que partía desde el Callao, llegara hasta La Oroya (1893) y Cerro
                            de Pasco (1904). El registro fotográfico detallado de principio a fin de esta línea férrea
                            consiguió imágenes de ingresos y salidas de túneles, de la extraordinaria ingeniería de
                            puentes, cruces e intercambios de vías, de las elevadas estaciones y yacimientos mineros, y
                            de los imponentes paisajes de lagunas y montañas nevadas.
                            <br><br>
                        </p>
                    </div>
                </div>

                <!--CEL-->
                <div class="row p2 menuWebPhone">
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/72/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img017.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 153 Línea del Callao a la Oroya. <br>
                                    Gran puente de verruga (tomado de abajo)<br>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/76/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img018.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 161 Línea del Callao a la Oroya. <br>
                                    Puente de Challapa <br>
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/80/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img019.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 169 Línea del Callao a la Oroya.<br> Estación de San Mateo <br>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/82/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img020.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 172 Línea del Callao a la Oroya. <br> Puente del infiernillo
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/96/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img021.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 200 Línea del Callao a la Oroya.<br>Túnel N° 52
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/96/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img022.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 203 Línea del Callao a la Oroya. <br>Laguna de Espadacocha
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/98/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img023.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 204 Línea del Callao a la Oroya. <br>Túnel de Galera, punto más elevado de la
                                    línea (4700 m.s.n.m.)
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/136/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img024.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 296 Locomotora N° 31 construida en la maestranza.<br> Factoría de
                                    ferrocarriles
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/136/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img025.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 299 Locomotora <br>N° 24 construida en la maestranza. <br>Factoría de
                                    ferrocarriles,
                                    Arequipa <br>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/142/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img026.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 316 Puno. <br>Puente entre Puno y Sicuani <br>
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/188/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img027.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 445 Estación del ferrocarril,<br> Huanchaco, Trujillo <br>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/190/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img028.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 453 Puente sobre el río Chicama,<br> La Libertad <br>
                                </p>
                            </div>
                        </a>
                    </div>
                </div>

                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/72/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img017.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 153 Línea del Callao a la Oroya. <br>
                                        Gran puente de verruga (tomado de abajo)<br>
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/76/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img018.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 161 Línea del Callao a la Oroya. <br>
                                        Puente de Challapa <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/80/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img019.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 169 Línea del Callao a la Oroya.<br> Estación de San Mateo <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/82/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img020.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 172 Línea del Callao a la Oroya. <br> Puente del infiernillo
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/96/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img021.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 200 Línea del Callao a la Oroya.<br>Túnel N° 52
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/96/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img022.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 203 Línea del Callao a la Oroya. <br>Laguna de Espadacocha
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/98/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img023.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 204 Línea del Callao a la Oroya. <br>Túnel de Galera, punto más elevado de la
                                        línea (4700 m.s.n.m.)
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/136/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img024.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 296 Locomotora N° 31 construida en la maestranza.<br> Factoría de
                                        ferrocarriles
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/136/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img025.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 299 Locomotora <br>N° 24 construida en la maestranza. <br>Factoría de
                                        ferrocarriles,
                                        Arequipa <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/142/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img026.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 316 Puno. <br>Puente entre Puno y Sicuani <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/188/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img027.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 445 Estación del ferrocarril,<br> Huanchaco, Trujillo <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/190/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img028.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 453 Puente sobre el río Chicama,<br> La Libertad <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="container_Gris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img width="100%" src="\assets\images\micrositio\micrositio5\ET02_MS06_ALBUM_LINEA_RESALTE.png">
                <p class="fontMS500 text-justify font-24">
                    <br>
                    NO BASTABA QUE EN AQUEL GRANDIOSO CERTAMEN UNIVERSAL, SÍNTESIS Y RESUMEN DE LOS PROGRESOS DEL SIGLO
                    DECIMONONO, ESTUVIERA REPRESENTADO EL PERÚ TAN SOLO POR SUS PRODUCTOS NATURALES E INDUSTRIALES, QUE
                    PODRÁN DAR UNA IDEA DE LA RIQUEZA Y FECUNDIDAD DE SU PRIVILEGIADO SUELO; SINO QUE TAMBIÉN ERA
                    PRECISO QUE ESTUVIERA POR SUS PRODUCCIONES INTELECTUALES, LAS QUE, A LA VEZ DE QUE DARÁN UNA IDEA
                    CABAL Y AMPLIA EN EL EXTRANJERO DEL ESTADO FLORECIENTE DE LAS LETRAS EN LA REPÚBLICA, SERÁN TIMBRE
                    DE HONOR Y DE GLORIA PARA UN PAÍS TAN JOVEN, Y QUE A PESAR DE SU AGITADA VIDA POLÍTICA Y ESCASO
                    TIEMPO DE EDUCACIÓN, HA LLEGADO A COLOCARSE EN ESTE TERRENO, A LA ALTURA DE LAS MÁS CIVILIZADAS
                    NACIONES DEL MUNDO.
                    <br>
                </p>
                <p class="text-right">
                    <span class="fontMS500Italic text-justify font-24">
                        CARLOS PRINCE, 1900. <br>COMISIONADO PARA FORMAR LA BIBLIOTECA PERUANA EN LA <br>EXPOSICIÓN
                        UNIVERSAL DE
                        PARÍS.
                    </span>
                </p>
                <img id="img_rotate" src="\assets\images\micrositio\micrositio5\ET02_MS06_ALBUM_LINEA_RESALTE.png">
            </div>
        </div>
    </div>
</div>

<div class="container_Blanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-2">
                        <img class="LineSubsec3 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada4.png">
                    </div>
                    <div class="col-sm-8">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LA IMPLEMENTACIÓN DEL PROYECTO
                        </p>
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec3 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada4.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-bottom: 0%;" class="text-center fontMS700 colorPrincipal font-40">
                    CIENTÍFICO Y EDUCATIVO DECIMONÓNICO
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada4.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br>
                    A MEDIADOS DEL SIGLO XIX, COMO CONSECUENCIA DE LA BONANZA POR LAS EXPORTACIONES DEL GUANO, LOS
                    INGRESOS FISCALES HICIERON POSIBLES LOS PLANES PARA CONSOLIDAR EL APARATO BUROCRÁTICO ESTATAL Y LA
                    MODERNIZACIÓN DEL PAÍS<br>
                </p>
                <p class="fontMS100 text-justify font-24">
                    <br>
                    Los grupos sociales dirigentes imaginaron una nación moderna, pero debían contar con los
                    profesionales adecuados para su implementación. Durante este periodo se fortalecieron las Facultades
                    de Medicina y de Ciencias de la Universidad de San Marcos y se estableció la Escuela de Ingenieros
                    (1876), lo que permitió el incremento de la posición social de sus miembros.
                    <br><br>
                    Los intelectuales de la élite gobernante de la posguerra (1885) asumieron el positivismo como un
                    discurso progresista de orden político y desarrollo económico. La ciencia y la educación fueron
                    consideradas como las principales herramientas para rehacer al Perú, por ello, en este periodo
                    surgieron en Lima sociedades científicas y asociaciones profesionales. Destacó la labor de la
                    Sociedad Geográfica de Lima (1888) y el rol de sus miembros en la documentación de las fronteras, la
                    investigación botánica y mineral y la elaboración de cartografía. Estas actividades tuvieron una
                    profunda convicción nacionalista y propusieron una integración del territorio a partir de la
                    ciencia, desarrollo económico e intervención política y administrativa del Estado. El siglo XIX
                    finalizaría con la irrupción de una corriente que revalorizaba y exigía la inclusión de la mayoría
                    indígena en los futuros proyectos de construcción de la nación.
                    <br><br>
                </p>

                <!--CEL-->
                <div class="row p2 menuWebPhone">

                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/16/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img029.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 27 Una sala del Hospital del 2 de Mayo, Lima
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/18/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img030.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 31 Cuarto de jaulas para internos.<br> Hospital Civil de la Misericordia,
                                    manicomio,
                                    Lima
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/20/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img031.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 35 Patio de facultad de Derecho, <br>Universidad de San Marcos
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/18/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img032.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 34. Escuela de Medicina, Lima
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/22/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img033.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 41 Observatorio meteorológico Unanue, Lima
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/24/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img034.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 44 Sociedad Geográfica, Lima
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/28/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img035.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 52 Interior del Instituto de Vacuna, Lima
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/132/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img036.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 285 Telescopio. <br>Observatorio astronómico, Arequipa
                                </p>
                            </div>
                        </a>
                    </div>

                </div>


                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/16/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img029.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 27 Una sala del Hospital del 2 de Mayo, Lima
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/18/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img030.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 31 Cuarto de jaulas para internos.<br> Hospital Civil de la Misericordia,
                                        manicomio,
                                        Lima
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/20/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img031.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 35 Patio de facultad de Derecho, <br>Universidad de San Marcos
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/18/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img032.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 34. Escuela de Medicina, Lima
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/22/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img033.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 41 Observatorio meteorológico Unanue, Lima
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/24/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img034.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 44 Sociedad Geográfica, Lima
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/28/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img035.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 52 Interior del Instituto de Vacuna, Lima
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/132/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img036.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 285 Telescopio. <br>Observatorio astronómico, Arequipa
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                </div>

                <br><br><br><br>
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LA INDUSTRIALIZACIÓN
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada2.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 2%;"
                    class="text-center fontMS700 colorPrincipal font-40">
                    PARA EL FUTURO DEL PAÍS
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada2.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br>
                    LA ECONOMÍA PERUANA DE FINES DE SIGLO XIX HABÍA EXPERIMENTADO UN CRECIMIENTO A CAUSA DE LA
                    EXPORTACIÓN DE MATERIAS PRIMAS COMO EL AZÚCAR Y EL ALGODÓN EN LA COSTA, LA LANA EN LA SIERRA SUR, EL
                    CAUCHO EN LA AMAZONÍA, LOS MINERALES EN LA SIERRA CENTRAL Y EL PETRÓLEO EN LA COSTA NORTE.
                    COMO CONSECUENCIA, LA ÉLITE FINANCIERA TUVO INFLUENCIA SOBRE LA POLÍTICA ECONÓMICA DEL ESTADO, TRAS
                    HABERSE ACABADO LOS INGRESOS DEL GUANO Y EL SALITRE.
                    <br><br>
                </p>
                <p class="fontMS100 text-justify font-24">
                    En 1896, se crearon la Sociedad Nacional de Industria, como órgano consultivo al gobierno y de
                    formación gremial, y el Instituto Técnico e Industrial del Perú como centro de información en
                    técnicas industriales. En Lima y Callao se encontraba el mayor porcentaje de fábricas de
                    manufacturas y productos de consumo y la mano de obra de los nuevos sectores obreros. De las
                    diversas industrias, la textil fue la que alcanzó mayor desarrollo y progreso, especialmente los
                    productos de tejido de algodón.
                    <br><br>
                    A fines del XIX, aún eran muchas las haciendas de la costa norte que estaban productivas, entre los
                    cultivos, la caña era el mayoritario, pero a principios del siglo XX, los hacendados tuvieron que
                    adaptarse a las formas de producción industrial y a la organización capitalista.
                    <br><br>
                </p>

                <!--CEL-->
                <div class="row p2 menuWebPhone">
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/48/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img037.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 98 Dinamos de la Empresa de Luz Eléctrica de Santa Catalina, Lima
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/50/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img038.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 103 Fábrica del gas, Lima
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/52/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img039.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 111 Fábrica de fósforos, Lima
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/94/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img040.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 196 Laboratorio y cuarto de ensayos. <br> Refinería de la mina en Aguas
                                    Calientes. Casapalca, Lima
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/134/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img041.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 290 Máquinas de hilado de la fábrica Huaico, Arequipa
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/174/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img042.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 405 Máquinas de destilación de la Hacienda Aspillaga en Cayaltí, Lambayeque
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/182/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img043.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 427 Hacienda Casa Grande, La Libertad
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/180/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img044.jpg">
                            <div class="overlay2">
                                <p class="fontMS500 text-center">
                                    N° 424 Centrifugas de la Hacienda Lurifico.<br> Chepén, La Libertad
                                </p>
                            </div>
                        </a>
                    </div>
                </div>


                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/48/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img037.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 98 Dinamos de la Empresa de Luz Eléctrica de Santa Catalina, Lima
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/50/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img038.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 103 Fábrica del gas, Lima
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/52/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img039.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 111 Fábrica de fósforos, Lima
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/94/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img040.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 196 Laboratorio y cuarto de ensayos. <br> Refinería de la mina en Aguas
                                        Calientes. Casapalca, Lima
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/134/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img041.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 290 Máquinas de hilado de la fábrica Huaico, Arequipa
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/174/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img042.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 405 Máquinas de destilación de la Hacienda Aspillaga en Cayaltí, Lambayeque
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/182/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img043.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 427 Hacienda Casa Grande, La Libertad
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/180/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img044.jpg">
                                <div class="overlay2">
                                    <p class="fontMS500 text-center">
                                        N° 424 Centrifugas de la Hacienda Lurifico.<br> Chepén, La Libertad
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<div class="container_AzulImg2">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-2">
                        <img class="LineSubsec3 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-8">
                        <p style="line-height: 120%;margin-bottom: 1%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LA RUTA HACIA EL AMAZONAS
                        </p>
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec3 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada4.png">
                    </div>
                </div>
                <p style="line-height: 120%;margin-bottom: 2%;" class="text-center fontMS300 colorPrincipal font-40">
                    CAMINO AL PICHIS
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada2.png">
                </div>
                <p class="fontMS500 text-center font-24 text-white">
                    <br>
                    EL PEDIDO DEL MINISTERIO DE FOMENTO Y OBRAS PÚBLICAS PARA LA CONFECCIÓN DEL <span
                        class="fontMS500Italic">ÁLBUM REPÚBLICA PERUANA
                        1900</span> SEÑALABA LA DOCUMENTACIÓN FOTOGRÁFICA DE LA VÍA DE PENETRACIÓN HACIA LA REGIÓN
                    AMAZÓNICA, QUE
                    PARTÍA DEL CALLAO HACIA LA OROYA EN JUNÍN Y CONTINUABA POR PASCO HASTA LLEGAR AL PUERTO DE EMBARQUE
                    FLUVIAL DEL RÍO PICHIS. DESDE ALLÍ SE NAVEGARÍA POR LOS RÍOS PACHITEA PRIMERO, LUEGO EL RÍO UCAYALI
                    HASTA SU CONFLUENCIA CON EL RÍO MARAÑÓN, CONTINUANDO POR EL RÍO AMAZONAS HASTA LA CIUDAD DE IQUITOS
                    DESDE DONDE SE REMONTARÍA HASTA LA COSTA ATLÁNTICA.
                    <br>
                </p>
                <p class="fontMS100 text-justify font-24 text-white">
                    <br>
                    Para este tramo Garreaud seleccionó las imágenes que diez años antes realizaron Charles Kroehle
                    junto a Georg Huëbner, entre 1888 y 1891. Ambos exploradores-empresarios tuvieron como objetivo
                    “formar una colección fotográfica de las regiones de ambos lados de los Andes y de grupos indígenas
                    desconocidos”. Su travesía generó cientos de imágenes del exuberante paisaje, de las comunidades
                    nativas asentadas a los márgenes de los ríos y la dinámica entre los colonizadores europeos y la
                    ocupación del territorio impulsada desde el Estado desde mediados del siglo XIX. Además, el álbum
                    incluyó vistas de las ciudades de Iquitos, Tarapoto, Lamas, Moyobamba y Chachapoyas.
                    Esta travesía generó alrededor de 200 imágenes la amazonia peruana. Sin duda, un extraordinario
                    logro para la época.
                    <br><br>
                </p>
                <!--CEL-->
                <div class="row p2 menuWebPhone">
                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/118/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img045.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N° 250 Colonia alemana de Pozuzo
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/118/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img046.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N° 252 Tarapoto, calle del Billar
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/118/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img047.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N° 253 Plaza e iglesia de Chachapoyas
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/120/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img048.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N° 258 Moyobamba, calle del Comercio
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/122/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img049.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N° 260 Lamas
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/122/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img050.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N°262 Pueblos Yanesha o Ashaninkas (denominados campas) en el río Palcazú, Pasco
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/122/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img051.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N° 264 Río Marañón. Puerto Juen, Celendín
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/124/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img052.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N° 268 Familia del pueblo Uni o Kakataibo, en su lengua “verdaderos
                                    hombre/gente”. Denominados cashibos. Habitan las regiones Ucayali y Huánuco
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/122/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img053.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N°263 Río Huallaga
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/118/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img054.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N°249 Puerto Bermúdez
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/124/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img055.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N° 266 Shipibo del río Pachitea
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/124/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img055a.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N° 251 Puente Silachi, Huancabamba
                                </p>
                            </div>
                        </a>
                    </div>

                </div>


                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/118/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img045.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N° 250 Colonia alemana de Pozuzo
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/118/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img046.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N° 252 Tarapoto, calle del Billar
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/118/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img047.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N° 253 Plaza e iglesia de Chachapoyas
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/120/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img048.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N° 258 Moyobamba, calle del Comercio
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/122/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img049.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N° 260 Lamas
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/122/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img050.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N°262 Pueblos Yanesha o Ashaninkas (denominados campas) en el río Palcazú, Pasco
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/122/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img051.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N° 264 Río Marañón. Puerto Juen, Celendín
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/124/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img052.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N° 268 Familia del pueblo Uni o Kakataibo, en su lengua “verdaderos
                                        hombre/gente”. Denominados cashibos. Habitan las regiones Ucayali y Huánuco
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/122/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img053.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N°263 Río Huallaga
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/118/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img054.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N°249 Puerto Bermúdez
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/124/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img055.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N° 266 Shipibo del río Pachitea
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/124/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img055a.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N° 251 Puente Silachi, Huancabamba
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                </div>

                <div class="row">
                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/124/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img056.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    Retrato de joven Shipibo
                                </p>
                            </div>
                        </a>

                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/124/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img056b.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    Retrato de joven Shipibo
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-8 libro p-3">
                        <p class="fontMS100 font-24 text-white">
                            <br><br><br>
                            Muchas de las fotografías realizadas por Kroele y Huëbner fueron comercializadas y
                            distribuidas entre coleccionistas e instituciones de investigación. La imagen del joven
                            shipibo se encuentra en repositorios de Alemania y Francia. La primera foto corresponde al
                            <span class="fontMS100Italic">Álbum República Peruana 1900</span>, está subexpuesta y opaca,
                            probablemente para facilitar su copia mediante la ilustración o el grabado. Este efecto da
                            como resultado un personaje sin detalle y sombrio. La segunda fotografía, en posesión de en
                            un repositorio francés, está correctamente revelada y nos muestra a un individuo muy joven y
                            sereno.
                        </p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
<div class="container_Azul_L">
    <div class="container">
        <img class="lineSep" width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA2.jpg">
    </div>
</div>
<div class="container_Azul">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec3 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-4 bottom_cel">
                        <p style="line-height: 160%;margin-bottom: 0%;margin-top: 5%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LIMA, UNA CAPITAL
                        </p>
                    </div>
                    <div class="c100">
                        <p style="line-height: 160%;margin-bottom: 0%;margin-top: 2%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LIMA, UNA CAPITAL
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec3 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-bottom: 2%;" class="fontMS700 text-center colorPrincipal font-40">
                    PARA EL MUNDO MODERNO
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada2.png">
                </div>
                <p class="fontMS500 text-center font-24 text-white">
                    <br>
                    LA BONANZA ECONÓMICA OBTENIDA DE LA EXPORTACIÓN DEL GUANO PERMITIÓ EL GRAN PROYECTO DE RENOVACIÓN
                    URBANA DE LA CIUDAD COMO ESPACIO PARA EL HOMBRE DE “VIDA MODERNA Y CIVILIZADA, CULTO Y ORDENADO”.
                    <br>
                </p>
                <p class="fontMS100 text-justify font-24 text-white">
                    <br>
                    Edificaciones como el hospital Dos de Mayo (1875), el manicomio (1859), la penitenciaría (1860) o el
                    matadero general (1855) respondían a preceptos de higiene y control del mundo industrializado. El
                    espacio público también fue sujeto de intervención con la creación del Parque de la Exposición
                    (1872), zona de “naturaleza planificada” para el encuentro social entre la burguesía. La expansión
                    de Lima, iniciada con la demolición de su muralla virreinal (1868), y de proyectados bulevares y
                    avenidas tuvo que detenerse con la Guerra del Pacífico (1879-1884). Luego de la forzada
                    interrupción, el ideal de modernidad
                    se extendió al desarrollo físico y moral mediante la práctica del deporte, como en el Club Ciclista
                    (1897) y a la necesidad de formar una nueva estética a través del teatro y las artes.
                    <br>
                </p>

                <!--CEL-->
                <div class="row p2 menuWebPhone">
                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/10/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img057.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N° 12 Lima. Interior de la Cámara de Diputados
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/22/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img058.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N° 39 Sala de lectura de la Biblioteca Nacional
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/22/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img059.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N°42 Sala de dibujo de la Academia Concha, Lima
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/24/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img060.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N° 46 Celdas de la Penitenciaría
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/30/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img061.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N° 56 Jardín de la Exposición
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/30/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img062.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N° 59 Estatua de Simón Bolívar.
                                    <br>
                                    Instalada en la antigua Plaza de la Inquisición en 1855
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/34/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img063.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N° 65 Velódromo del Club Ciclista
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/34/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img064.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N° 66 Patio y fachada del Teatro Nacional
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-4 libro p-3">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/42/"
                            target="_blank" style="color: black;">
                            <img width="100%" src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img065.jpg">
                            <div class="overlay3">
                                <p class="fontMS500 text-center">
                                    N° 85 Matadero general, departamento de matanza de corderos
                                </p>
                            </div>
                        </a>
                    </div>
                </div>

                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/10/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img057.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N° 12 Lima. Interior de la Cámara de Diputados
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/22/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img058.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N° 39 Sala de lectura de la Biblioteca Nacional
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/22/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img059.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N°42 Sala de dibujo de la Academia Concha, Lima
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/24/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img060.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N° 46 Celdas de la Penitenciaría
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/30/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img061.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N° 56 Jardín de la Exposición
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/30/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img062.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N° 59 Estatua de Simón Bolívar.
                                        <br>
                                        Instalada en la antigua Plaza de la Inquisición en 1855
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/34/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img063.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N° 65 Velódromo del Club Ciclista
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/34/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img064.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N° 66 Patio y fachada del Teatro Nacional
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/42/"
                                target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_img065.jpg">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        N° 85 Matadero general, departamento de matanza de corderos
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <br>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="container_Verde">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/album-republica-peruana-1900/4/"
                            target="_blank" style="color: black;">
                            <img class="img-fluid mb-3 pointer" width="100%"
                                src="\assets\images\micrositio\micrositio5\ET02_MS06_ALBUM_img066.jpg">
                        </a>
                    </div>
                    <div class="col-sm-8">
                        <p class="text-white fontMS500 font-24">
                            En 1874, se erigió el monumento al Combate del Dos de Mayo en Lima. Este conmemora la
                            victoria naval de las naciones de Perú, Chile, Bolivia y Ecuador sobre la Armada Española en
                            el enfrentamiento que se dio en las costas del Callao en 1866. Diseñado en mármol y bronce
                            en Francia, el conjunto presenta en su pedestal cuatro estatuas de las repúblicas aliadas y
                            una columna coronada por una estatua alada que representa la victoria. La fotografía de este
                            monumento se encuentra como inicio del
                            <span class="fontMS500Italic">
                                Album República Peruana 1900
                            </span>
                            perteneciente a la Biblioteca Nacional del Perú.
                        </p>
                    </div>
                    <div class="col-sm-12 mb-5 mt-4">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            ¿QUÉ MONUMENTOS PÚBLICOS DE LA CIUDAD DE LIMA CONOCES Y CONSIDERAS IMPORTANTES? ¿POR QUÉ?
                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            EL ÁLBUM TESTIMONIA UNA REPRESENTACIÓN DEL PERÚ COMO UNA NACIÓN ENRUMBADA HACIA EL PROGRESO.
                            SEGÚN LAS FOTOGRAFÍAS, ¿CÓMO DEFINIRÍAS EL PROGRESO?
                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            ¿CUÁLES FOTOS TE HAN LLAMADO MÁS LA ATENCIÓN? ¿POR QUÉ? TE INVITAMOS A INVESTIGAR SOBRE LOS
                            LUGARES DE LAS FOTOS QUE HAS SELECCIONADO.
                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container_Blanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio5/ET02_MS06_ALBUM_LINEA1-recortada2.png">
                    </div>
                </div>
                <p class="fontMS100 font-24">
                    <br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación:
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS100 font-24">
                            <span class="fontMS500 font-24">
                                Contreras, C. y Cueto, M. (2008)
                            </span><br>
                            <span class="fontMS100Italic font-24">
                                Caminos, ciencia y Estado en el Perú, 1850-1930. <br>
                            </span>
                            En: História, Ciências, Saúde–Manguinhos, Rio de Janeiro, v.15, n.3,
                            p.635-655, jul.-set. 2008. <br>
                            <a href="https://www.google.com.pe/url?sa=t&rct=j&q=&esrc=s&source=web&cd=&ved=2ahUKEwiYvtGZtbftAhXwGbkGHSHpDCMQFjAAegQIAxAC&url=https%3A%2F%2Fcore.ac.uk%2Fdownload%2Fpdf%2F206827914.pdf&usg=AOvVaw3WmlVxu9mK__-8i6XhAryk"
                                target="_blank">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <br>
                        <p class="fontMS100 font-24">
                            <span class="fontMS500 font-24">Múñoz, F. (2001)</span><br>
                            <span class="fontMS100Italic font-24">
                                Diversiones públicas en Lima 1890-1920: la experiencia de la modernidad. <br>
                            </span>
                            Lima: Red para el Desarrollo de las Ciencias Sociales en el Perú. <br>
                            <a href="https://repositorio.up.edu.pe/handle/11354/2389" target="_blank">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100 font-24">
                            <span class="fontMS500 font-24">Contreras, C. (2011)</span><br>
                            <span class="fontMS100Italic font-24">
                                Compendio de historia económica del Perú. Tomo IV: Economía de la primera centuria
                                independiente.
                                <br>
                            </span>
                            Lima: Banco Central de Reserva del Perú – Instituto de Estudios Peruanos
                            <br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=369075" target="_blank">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100 font-24">
                            <span class="fontMS500 font-24">
                                Fotografías de Charles Kroehle y Georg Hüebner
                            </span>
                            <br>
                            Buscador del repositorio virtual de la Colección del Museo Etnológico de Berlín<br>
                            <a href="http://www.smb-digital.de/eMuseumPlus?service=ExternalInterface&module=collection&moduleFunction=highlight"
                                target="_blank">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 font-24">
                            <span class="fontMS500 font-24">La Serna, J.C. (2018)</span><br>
                            <span class="fontMS100Italic font-24">
                                Bosque, fotografía y exposición: La construcción visual de la Amazonía a
                                través de los clichés de Charles Kroehle y el Álbum República peruana 1900. <br>
                            </span>
                            En: En Líneas Generales, n.º 002, pp. 41-55, nov. 2018 Universidad de Lima.
                            <br>
                            <a href="https://revistas.ulima.edu.pe/index.php/enlineasgenerales/article/view/2666/2850"
                                target="_blank">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <br>
                        <p class="fontMS100 font-24">
                            <span class="fontMS500 font-24">Mori, J. (2017)</span><br>
                            <span class="fontMS100Italic font-24">
                                “Álbum República Peruana 1900 de Fernando Garreaud (índice, estudio y
                                notas)”. <br>
                            </span>
                            En Boletín de la Biblioteca Nacional del Perú, N° 99, Lima, noviembre, pp.
                            211-279.<br>
                        </p>
                        <p class="fontMS100 font-24">
                            <span class="fontMS500 font-24">Ramón, G. (2004)</span><br>
                            <span class="fontMS100Italic font-24">
                                El guión de la cirugía urbana: Lima, 1850-1940.
                                <br>
                            </span>
                            En: Ensayos en Ciencias Sociales, Vol 3. Lima: Fondo Editorial de la Facultad de Ciencias
                            Sociales. pp. 9 - 33
                            <br>
                            <a href="https://www.google.com/url?sa=t&rct=j&q=&esrc=s&source=web&cd=&ved=2ahUKEwiTht-g1M7tAhUSH7kGHYV4DtYQFjABegQIBBAC&url=https%3A%2F%2Fsisbib.unmsm.edu.pe%2Fbibvirtualdata%2Flibros%2FCSociales%2Fensayos_ciencias%2Fv1n1%2Fa02.pdf&usg=AOvVaw3abG-Ml_RJi4GK2krcKsDp"
                                target="_blank">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100 font-24">
                            <span class="fontMS500 font-24">Ministerio de Cultura
                            </span><br>
                            Base de datos de pueblos indígenas u originarios

                            <br>
                            <a href="https://bdpi.cultura.gob.pe/" target="_blank">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>